import { useEffect, useState } from "react";
import { loadImageAsync } from "./utils";

export const useImage = (src: string) => {
  const [dataUrl, setDataUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    loadImageAsync(src)
      .then((imageSrc) => setDataUrl(imageSrc))
      .catch(() => setDataUrl(undefined));
  }, [src]);

  return dataUrl;
};
